import React, { Component } from "react";
import { connect } from 'react-redux';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import {Modal} from "react-bootstrap";

// reactstrap components
import { Button, Container } from "reactstrap";
import { useNavigate } from "react-router";

class AdminSignout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      logoutEnabled: true
    }
    this.setShow = this.setShow.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  setShow(bool) {
    this.setState({ show: bool });
  }

  handleClose = () => { 
    this.setShow(false);

    delete this.props.response.login.response;
    this.props.response.login.adminId = '';
    this.props.response.login.adminName = '';
    this.props.response.login.isSignedIn = false;
    this.props.response.login.isSuperAdmin = false;
    this.props.response.login.isStateAdmin = false;
    this.props.response.login.redirectAfterSignInTo = undefined;
    this.props.response.login.userToken= '';
    this.props.response.login.roles= [];
    if(this.props.response.donor.hasOwnProperty('allDonors') && this.props.response.donor.allDonors)
      this.props.response.donor.allDonors = '';
    this.props.navigate('/liquidlove/login');
  };

  handleCancel = () => { 
    this.setShow(false);
    if (!this.props.response.login.isSignedIn)
      this.props.navigate('/liquidlove/login');
    else
      this.props.navigate('/liquidlove/home');
  };
  
  handleShow = () => { this.setShow(true) };

  render() {
    let message;
    if (!this.props.response.login.isSignedIn){
      message = 'Sairam! You are NOT logged in';
      this.state.logoutEnabled = false;
    }
    else
      message = 'Sairam! Are you sure to logout?';
    return(
      <div className="wrapper">
        <HomeNav adminName={this.props.response.login.adminName}/>
        <HomePageHeader />
        <div  className="section section-signup"
          style={{
            backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center",
            minHeight: "700px",
          }}
        >
          <Container>        
            <Modal
            centered
            show={this.state.show}
            onHide={this.handleClose}
            backdrop="static"
            keyboard={false}
            >
              <Modal.Body>
                {message}
              </Modal.Body>
              <Modal.Footer>
                <Button disabled={!this.state.logoutEnabled} className="btn btn-primary mr-2" variant="primary" onClick={this.handleClose}>
                  Logout
                </Button>
                <Button className="btn btn-secondary mr-2" variant="secondary" onClick={this.handleCancel}>
                  Cancel
                </Button>                
              </Modal.Footer>
            </Modal>
          </Container>
        </div>
        <DefaultFooter />
      </div>
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  return <AdminSignout navigate={navigate} {...props} />
});